import { Subject } from 'rxjs';

import { AudioEditor } from './AudioEditor';

export default class SegmentBar {
  public mixPoint = 0;
  public introPoint = 0;
  public outroPoint = 0;

  public isMixActive = false;
  public isIntroActive = false;
  public isOutroActive = false;

  constructor(
    private readonly audioEditor: AudioEditor,
    private readonly mixSubject: Subject<SegmentBar>,
    private readonly outroSubject: Subject<SegmentBar>,
    private readonly introSubject: Subject<SegmentBar>,
  ) {
    audioEditor.onWaveformLoaded$.subscribe(() => {
      this.mixPoint = audioEditor.options.mix.at;
      this.isMixActive = audioEditor.options.mix.isActive;
      this.introPoint = audioEditor.options.intro.at;
      this.isIntroActive = audioEditor.options.intro.isActive;
      this.outroPoint = audioEditor.options.outro.at;
      this.isOutroActive = audioEditor.options.outro.isActive;
      // force refresh by fake triggering a update
      this.mixSubject.next(this);
    });
  }

  setMixPoint(time: number) {
    this.setMixOrExtro(time);
  }

  hideMixPoint() {
    this.mixPoint = 0;
    this.isMixActive = false;
    this.mixSubject.next(this);
  }

  setIntroPoint(time: number) {
    let realTime = time;
    if (time < this.audioEditor.selectionBox.from) {
      realTime = this.audioEditor.selectionBox.from;
    } else if (
      (this.isMixActive && time > this.mixPoint) ||
      (this.isOutroActive && time > this.outroPoint)
    ) {
      if (!this.isMixActive) {
        realTime = this.outroPoint;
      } else if (!this.isOutroActive) {
        realTime = this.mixPoint;
      } else {
        realTime = Math.min(this.mixPoint, this.outroPoint);
      }
    } else if (time > this.audioEditor.selectionBox.to) {
      realTime = this.audioEditor.selectionBox.to;
    }
    this.isIntroActive = true;
    this.introPoint = realTime;
    this.introSubject.next(this);
  }

  hideIntroPoint() {
    this.introPoint = 0;
    this.isIntroActive = false;
    this.introSubject.next(this);
  }

  setOutroPoint(time: number) {
    this.setMixOrExtro(time, false);
  }

  setMixOrExtro(time: number, isMix = true) {
    let realTime = time;
    if (this.isIntroActive && time < this.introPoint) {
      realTime = this.introPoint;
    } else if (time < this.audioEditor.selectionBox.from) {
      realTime = this.audioEditor.selectionBox.from;
    } else if (time > this.audioEditor.selectionBox.to) {
      realTime = this.audioEditor.selectionBox.to;
    }
    if (isMix) {
      this.isMixActive = true;
      this.mixPoint = realTime;
      this.mixSubject.next(this);
    } else {
      this.isOutroActive = true;
      this.outroPoint = realTime;
      this.outroSubject.next(this);
    }
  }

  hideOutroPoint() {
    this.outroPoint = 0;
    this.isOutroActive = false;
    this.outroSubject.next(this);
  }
}
